export const DESKTOP_BREAKPOINT = 1340;
export const TABLET_BREAKPOINT = 1080;
export const MOBILE_BREAKPOINT = 800;
export const SMALL_MOBILE_BREAKPOINT = 400;
